export const MINI_GAME_CLASSES = new Set(["crash", "mines", "plinko", "casual", "lottery"]);

/**
 * @param {{ class?: string; name?: string } | null | undefined} game
 */
export function isMiniGame(game) {
  if (!game) return false;
  const cls = game.class?.toLowerCase();
  if (cls && MINI_GAME_CLASSES.has(cls)) return true;
  return game.name?.toLowerCase().includes("chicken") ?? false;
}
